// extracted by mini-css-extract-plugin
module.exports = {"title":"blogTemplate-module--title--3S--G","date":"blogTemplate-module--date--wlawP"};